import type {
    Banner,
    ColorVariation,
    Product,
    ProductComparisonBanner,
    SearchContext,
    SimilarProductHeader,
    Slider,
    Variation,
} from '@shared/types/types.ts';

export type SponsoredDisplayAd = {
    type: 'SponsoredDisplayAd';
    searchContext?: SearchContext;
    /*                                                                          */
    hidden?: true;
};

export type TileItem = ProductItem;

export type ProductItem = {
    product: Product;
    variations: Variation[];
    localListPosition: number;
    actualListPosition: number;
    originPosition: number;
    colors?: ColorVariation[];
    currentVariationId?: Variation['variationId'];
    /*                                                                                      */
    variationLoadFailed?: boolean;
    type: 'AS' | 'BOOSTED';
};

export type BenefitCinemaItem = {
    type: 'BenefitCinema';
};

/**
 *
 *
 */
export type BlackFridaySliderItem =
    | { type: 'BlackFridaySlider'; state: 'pending'; rule?: string }
    | { type: 'BlackFridaySlider'; state: 'collapsed' }
    | ReadyBlackFridaySliderItem;

export type ReadyBlackFridaySliderItem = {
    type: 'BlackFridaySlider';
    state: 'ready';
    items: ProductItem[];
    scrollLeft?: number;
    /*                                                                                                             */
    trackedSponsoredViews?: number[];
};

/*                                                                                                       */
export type ComboKind = 'outfit' | 'home';

export type ComboItem = {
    type: 'Combo';
    comboId: string;
    moodImage: string;
    variationIds: string[];
    kind: ComboKind;
    /*                                                                                               */
    localListPosition: number;
    /*                                                                                              */
    actualListPosition: number;
};

/*                                                                        */
export type ComboContent = Omit<ComboItem, 'localListPosition' | 'actualListPosition'>;

export type TileListItem =
    | SimilarProductHeader
    | Banner
    | Slider
    | ProductComparisonBanner
    | ProductItem
    | SponsoredDisplayAd
    | BenefitCinemaItem
    | BlackFridaySliderItem
    | ComboItem;

export function isProductItem(item: TileListItem): item is ProductItem {
    return ['AS', 'BOOSTED'].includes(item.type);
}

export function isBlackFridaySliderItem(item: TileListItem): item is BlackFridaySliderItem {
    return item.type === 'BlackFridaySlider';
}

export function isComboItem(item: TileListItem): item is ComboItem {
    return item.type === 'Combo';
}

/*                                                          */
export function isTileSlotItem(item: TileListItem): item is ProductItem | ComboItem {
    return isProductItem(item) || isComboItem(item);
}
